<template>
  <div class="p-4 chart-leak-size-documents">
    <h4>{{ chartRoute.title }}</h4>
    <p>The more than 11.9 million files that make up the Pandora Papers come from 14 different offshore service providers.</p>
    <stacked-column-chart
      :data="$options.tsv"
      :social-mode="socialMode"
      :social-mode-ratio="0.75"
      :fixed-height="fixedHeight"
      hide-legend
      no-tooltips
      bar-max-width="50%"
      :y-axis-tick-format="value => `${value} million`"
      label-field="label" />
    <p class="text-muted mt-2 small text-right">Source: ICIJ</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartLeakSizeDocuments'
}
</script>

<style lang="scss" scoped>
.chart-leak-size-documents /deep/ .stacked-column-chart {

  &__groups__item {

    &:nth-child(1) .stacked-column-chart__groups__item__bars__item,
    &:nth-child(2) .stacked-column-chart__groups__item__bars__item {
      background: var(--group-color-3n);

      .chart--social-mode & {
        background: #433;
      }
    }
  }
}
</style>

<tsv>
label	value
Panama Papers (2016)	11.5
Paradise Papers (2017)	13.4
Pandora Papers (2021)	11.9
</tsv>
